@if (data.title) {
  <h1 mat-dialog-title>
    <mat-icon color="accent">error_outline</mat-icon>
    <span>{{ data.title }}</span>
  </h1>
}
<mat-dialog-content>
  <p>{{ data.message }}</p>
  @if (data.option; as option) {
    <div class="dialog-option">
      <mat-checkbox
        color="primary"
        [checked]="optionChecked"
        (change)="optionChecked = $event.checked"
      >
        {{ option.label }}
      </mat-checkbox>
      @if (option.hint) {
        <div class="dialog-option-hint">
          {{ option.hint }}
        </div>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.showCancel) {
    <button type="button" mat-flat-button [mat-dialog-close]="false">Cancel</button>
  }
  <button
    type="button"
    mat-raised-button
    [color]="data.confirmColor"
    [mat-dialog-close]="confirmResult"
  >
    {{ data.action ? data.action : "Confirm" }}
  </button>
</mat-dialog-actions>
